import { SnLprFlockRead } from '../models';

/**
 * Interface used for mapping of results returned by the API for Flock.
 */
export interface FlockLprResults {
  links: {
    next: string;
    previous: string;
  };
  results: SnLprFlockRead[];
  messages: string;
  resultCount: number;
  status?: number;
}
